import Vue from 'vue';
import Router from 'vue-router';
import HeaderComponent from '@/components/HeaderComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  /**
   * @param {Route} to
   */
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    }

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        default: Home,
        header: HeaderComponent,
        footer: FooterComponent,
      },
    },
  ],
});
